var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['button', { 'button--outlined': _vm.outlined }],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('button-click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }